import { useAtomValue, useSetAtom } from 'jotai';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { documentTitlePrefixAtom, objectTitleAtom } from '@frontend/atoms';

const PAGE_TITLES: Record<string, string> = {
  chat: 'Chats',
  instructions: 'Instructions',
  skills: 'Instructions',
  agents: 'Agents',
  tools: 'Tools',
  settings: 'Settings',
  notifications: 'Notification Center',
  artifacts: 'Artifacts',
  context: 'Context',
  plugins: 'Plugins',
  stickyboard: 'Stickyboard',
  vaus: 'Virtual Agentic Users',
};

const MAX_TITLE_LENGTH = 30;

const truncateTitle = (title: string, maxLength: number = MAX_TITLE_LENGTH): string => {
  if (title.length <= maxLength) {
    return title;
  }
  return `${title.slice(0, maxLength).trim()}...`;
};

export const useRouteDocumentTitle = () => {
  const location = useLocation();
  const objectTitle = useAtomValue(objectTitleAtom);
  const prefix = useAtomValue(documentTitlePrefixAtom);

  useEffect(() => {
    const pathParts = location.pathname.split('/');
    const section = pathParts[3];
    const pageTitle = PAGE_TITLES[section];

    if (pageTitle && objectTitle) {
      const truncatedObjectTitle = truncateTitle(objectTitle);
      document.title = `${prefix}${pageTitle} • ${truncatedObjectTitle} | Opal`;
    } else if (pageTitle) {
      document.title = `${prefix}${pageTitle} | Opal`;
    } else {
      document.title = `${prefix}Opal`;
    }
  }, [location.pathname, objectTitle, prefix]);
};

export const useObjectTitle = (title: string | null | undefined) => {
  const setObjectTitle = useSetAtom(objectTitleAtom);

  useEffect(() => {
    if (title) {
      setObjectTitle(title);
    }
    return () => setObjectTitle(null);
  }, [title, setObjectTitle]);
};
